import { render, staticRenderFns } from "./IconInformationCircle20.vue?vue&type=template&id=1dd0d1f4&"
import script from "./IconInformationCircle20.vue?vue&type=script&lang=ts&"
export * from "./IconInformationCircle20.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports